// ─────────────────────────────────────────────────────────────
// Modal — Reusable modal system
// ─────────────────────────────────────────────────────────────
import { toastError } from '@/ui/toast';

type OnCommit = (() => void | Promise<void>) | null;

let _onCommit: OnCommit = null;

export function openModal(
  title: string,
  html:  string,
  onSave: OnCommit
): void {
  const titleEl = document.getElementById('modal-title');
  const bodyEl  = document.getElementById('modal-body');
  const overlay = document.getElementById('overlay');
  const saveBtn = document.getElementById('modal-save-btn') as HTMLButtonElement | null;
  const cancelBtn = document.querySelector('.modal-btns .btn-g') as HTMLButtonElement | null;

  if (!titleEl || !bodyEl || !overlay) return;

  titleEl.textContent = title;
  bodyEl.innerHTML    = html;
  _onCommit           = onSave;

  if (saveBtn)  { saveBtn.style.display = onSave ? '' : 'none'; saveBtn.textContent = 'Salvar'; saveBtn.disabled = false; }
  if (cancelBtn){ cancelBtn.textContent = 'Cancelar'; }

  overlay.classList.add('open');
}

export function closeModal(): void {
  const overlay   = document.getElementById('overlay');
  const saveBtn   = document.getElementById('modal-save-btn') as HTMLButtonElement | null;
  const cancelBtn = document.querySelector('.modal-btns .btn-g') as HTMLButtonElement | null;

  if (overlay) overlay.classList.remove('open');
  _onCommit = null;

  if (saveBtn)   { saveBtn.style.display = ''; saveBtn.textContent = 'Salvar'; saveBtn.disabled = false; }
  if (cancelBtn) { cancelBtn.textContent = 'Cancelar'; }
}

export async function commitModal(): Promise<void> {
  const btn = document.getElementById('modal-save-btn') as HTMLButtonElement | null;
  if (!btn) return;

  btn.disabled    = true;
  btn.textContent = 'Salvando...';

  try {
    if (_onCommit) await _onCommit();
    closeModal();
  } catch (e) {
    toastError(e instanceof Error ? e.message : 'Erro ao salvar.');
    btn.disabled    = false;
    btn.textContent = 'Salvar';
  }
}

export function closeOverlayOutside(e: MouseEvent): void {
  if ((e.target as Element)?.id === 'overlay') closeModal();
}

export function initModalSwipe(): void {
  const modal = document.querySelector('.modal') as HTMLElement | null;
  if (!modal) return;

  let startY = 0;
  let dragging = false;

  modal.addEventListener('touchstart', (e) => {
    startY   = e.touches[0].clientY;
    dragging = false;
    modal.style.transition = 'none';
  }, { passive: true });

  modal.addEventListener('touchmove', (e) => {
    const dy = e.touches[0].clientY - startY;
    if (dy > 0) {
      dragging = true;
      modal.style.transform = `translateY(${dy}px)`;
    }
  }, { passive: true });

  modal.addEventListener('touchend', (e) => {
    modal.style.transition = '';
    const dy = e.changedTouches[0].clientY - startY;
    modal.style.transform  = '';
    if (dragging && dy > 80) closeModal();
    dragging = false;
  });
}

/** Confirmation modal — replaces window.confirm() */
export function confirmModal(message: string): Promise<boolean> {
  return new Promise(resolve => {
    openModal('Confirmar', `
      <p style="font-size:14px;color:var(--text);line-height:1.6">${message}</p>`,
      () => { resolve(true); }
    );

    // Override cancel to resolve false
    const cancelBtn = document.querySelector('.modal-btns .btn-g') as HTMLButtonElement | null;
    if (cancelBtn) {
      const original = cancelBtn.onclick;
      cancelBtn.onclick = () => {
        resolve(false);
        cancelBtn.onclick = original;
        closeModal();
      };
    }

    // Style the save button as danger for confirmations
    const saveBtn = document.getElementById('modal-save-btn') as HTMLButtonElement | null;
    if (saveBtn) {
      saveBtn.style.background = 'var(--lux-red)';
      saveBtn.textContent      = 'Confirmar';
    }
  });
}
